import Nav from "@material-tailwind/react/Nav";
import Navbar from "@material-tailwind/react/Navbar";
import NavbarBrand from "@material-tailwind/react/NavbarBrand";
import NavbarCollapse from "@material-tailwind/react/NavbarCollapse";
import NavbarContainer from "@material-tailwind/react/NavbarContainer";
import NavbarToggler from "@material-tailwind/react/NavbarToggler";
import NavbarWrapper from "@material-tailwind/react/NavbarWrapper";
import NavLink from "@material-tailwind/react/NavLink";
import React, { useState } from "react";
import Fade from 'react-reveal/Fade';

export default function NavBar() {
    const [openNavbar, setOpenNavbar] = useState(false);

    return (
        <Navbar className="w-full" color="lightBlue" navbar>
            <NavbarContainer>
                <NavbarWrapper>
                    <Fade left><NavbarBrand>
                        <p className="text-2xl font-bold text-white border-2 border-white px-4 py-2">S</p>
                    </NavbarBrand></Fade>
                    <NavbarToggler
                        color="white"
                        onClick={() => setOpenNavbar(!openNavbar)}
                        ripple="light"
                    />
                </NavbarWrapper>

                <Fade right>
                    <NavbarCollapse open={openNavbar}>
                        <Nav>
                            <NavLink href="#about" ripple="light">
                                About Me
                            </NavLink>
                            <NavLink href="#skills" ripple="light">
                                Skills
                            </NavLink>
                            <NavLink href="#projects" ripple="light">
                                Projects
                            </NavLink>
                            <NavLink href="#blogs" ripple="light">
                                Blogs
                            </NavLink>
                            <NavLink href="#contact" ripple="light">
                                Contact
                            </NavLink>
                        </Nav>
                    </NavbarCollapse>
                </Fade>

            </NavbarContainer>
        </Navbar>
    );
}